/* global axios */
import ApiClient from '../ApiClient';

class MyAiPreferences extends ApiClient {
  constructor() {
    super('my_ai/preferences', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  updatePreferences(data) {
    return axios.put(this.url, data);
  }
}

export default new MyAiPreferences();
